var _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 14,
    viewBox: "0 0 58 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Text_Button",
    "data-name": "Text Button",
    transform: "translate(29 11)",
    fill: "#2067ed",
    fontSize: 10,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -28,
    y: 0
  }, "Text Button"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextButton);
export default __webpack_public_path__ + "static/media/TextButton.b4a29a1b3fde76bcede9767ecab1f176.svg";
export { ForwardRef as ReactComponent };